// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangePassword_form__3DOLY"};